export const ToasterMixin = {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        toaster (payload) {
          this.$store.dispatch('toast', payload).then(id => {
            this.$store.dispatch('hideToast', id)
          })
        }
      }
    })
  }
}

export const toaster = (store, payload) => {
  store.dispatch('toast', payload).then(id => {
    store.dispatch('hideToast', id)
  })
}
